(function () {
  function init() {
    var list = document.querySelector('[data-catalogo-list]');
    if (!list) return;

    document.body.classList.add('catalogo-simples-page');

    var wrapper = document.querySelector('.catalogo-simples-wrapper');
    var fragmentView = wrapper ? wrapper.getAttribute('data-fragment-view') : 'catalogo-fragment';

    var viewportMeta = document.querySelector('meta[name="viewport"]');
    var originalViewportContent = viewportMeta ? viewportMeta.getAttribute('content') : null;

    function preventAutoZoom(el) {
      if (!el || !viewportMeta || !originalViewportContent) return;
      el.addEventListener('focus', function () {
        viewportMeta.setAttribute('content', originalViewportContent + ', maximum-scale=1');
      });
      el.addEventListener('blur', function () {
        viewportMeta.setAttribute('content', originalViewportContent);
      });
    }

    var catalogItems = [];
    var categoryItems = [];
    var items = catalogItems;
    var currentCategoryHandle = '';
    var allCatalogHolder = document.createElement('div');
    allCatalogHolder.style.display = 'none';
    document.body.appendChild(allCatalogHolder);

    var emptyMsg = document.querySelector('[data-catalogo-empty]');
    var emptyMsgOriginalText = emptyMsg ? emptyMsg.textContent : '';
    var categorySelect = document.querySelector('[data-filter-category]');
    var colorSelect = document.querySelector('[data-filter-color]');
    var sizeSelect = document.querySelector('[data-filter-size]');
    var sortSelect = document.querySelector('[data-filter-sort]');
    var clearBtn = document.querySelector('[data-filter-clear]');
    var loadMoreBtn = document.querySelector('[data-catalogo-loadmore]');
    var searchInput = document.querySelector('[data-filter-search]');
    var searchClearBtn = document.querySelector('[data-filter-search-clear]');

    function bindItem(item, targetArray) {
      var wrapperEl = item.querySelector('[data-composicao-wrapper]');
      if (wrapperEl) {
        var text = wrapperEl.querySelector('[data-composicao-text]');
        var toggle = wrapperEl.querySelector('[data-composicao-toggle]');
        if (text && toggle) {
          if (text.scrollWidth > text.clientWidth + 1) {
            toggle.classList.add('is-visible');
          }
          toggle.addEventListener('click', function () {
            var expanded = wrapperEl.classList.toggle('is-expanded');
            toggle.textContent = expanded ? '–' : '+';
            toggle.setAttribute('aria-label', expanded ? 'Ver menos' : 'Ver mais');
          });
        }
      }

      var arrow = item.querySelector('[data-catalogo-arrow]');
      if (arrow) {
        arrow.addEventListener('click', function () {
          var scroller = arrow.parentElement.querySelector('[data-catalogo-scroller]');
          if (!scroller) return;
          scroller.scrollBy({ left: 240, behavior: 'smooth' });
        });
      }

      var stockToggle = item.querySelector('[data-stock-toggle]');
      var stockMatrix = item.querySelector('[data-stock-matrix]');
      if (stockToggle && stockMatrix) {
        stockToggle.addEventListener('click', function () {
          var isHidden = stockMatrix.hidden;
          stockMatrix.hidden = !isHidden;
          stockToggle.textContent = isHidden ? 'Ocultar estoque' : 'Ver estoque';
        });
      }

      (targetArray || items).push(item);
    }

    Array.prototype.slice.call(list.querySelectorAll('[data-catalogo-item]')).forEach(function (item) {
      bindItem(item, catalogItems);
    });

    [categorySelect, colorSelect, sizeSelect, sortSelect, searchInput].forEach(preventAutoZoom);

    function matchesValue(value, attr) {
      if (!value) return true;
      var raw = attr || '';
      return raw.split('|').indexOf(value) !== -1;
    }

    function countVisible() {
      var count = 0;
      items.forEach(function (item) {
        if (!item.hidden) count++;
      });
      return count;
    }

    function applyFilters() {
      var color = colorSelect ? colorSelect.value : '';
      var size = sizeSelect ? sizeSelect.value : '';
      var search = searchInput ? searchInput.value.trim().toLowerCase() : '';

      items.forEach(function (item) {
        var itemColors = item.getAttribute('data-colors') || '';
        var itemSizes = item.getAttribute('data-sizes') || '';
        var itemTitle = item.getAttribute('data-title-sort') || '';

        var show =
          matchesValue(color, itemColors) &&
          matchesValue(size, itemSizes) &&
          (!search || itemTitle.indexOf(search) !== -1);

        item.hidden = !show;
      });
    }

    function applySort() {
      var sortValue = sortSelect ? sortSelect.value : '';
      if (!sortValue) return;

      var sorted = items.slice().sort(function (a, b) {
        switch (sortValue) {
          case 'created-desc':
            return Number(b.getAttribute('data-created')) - Number(a.getAttribute('data-created'));
          case 'created-asc':
            return Number(a.getAttribute('data-created')) - Number(b.getAttribute('data-created'));
          case 'price-asc':
            return Number(a.getAttribute('data-price')) - Number(b.getAttribute('data-price'));
          case 'price-desc':
            return Number(b.getAttribute('data-price')) - Number(a.getAttribute('data-price'));
          case 'title-asc':
            return (a.getAttribute('data-title-sort') || '').localeCompare(b.getAttribute('data-title-sort') || '');
          case 'title-desc':
            return (b.getAttribute('data-title-sort') || '').localeCompare(a.getAttribute('data-title-sort') || '');
          default:
            return 0;
        }
      });

      sorted.forEach(function (item) {
        list.appendChild(item);
      });
    }

    function finalizeFilterPass() {
      applyFilters();
      applySort();
      if (emptyMsg) {
        emptyMsg.textContent = emptyMsgOriginalText;
        emptyMsg.hidden = countVisible() !== 0;
      }
    }

    function updateUrl() {
      var params = new URLSearchParams(window.location.search);

      var map = {
        categoria: categorySelect,
        cor: colorSelect,
        tamanho: sizeSelect,
        ordenar: sortSelect
      };

      Object.keys(map).forEach(function (key) {
        var select = map[key];
        if (select && select.value) {
          params.set(key, select.value);
        } else {
          params.delete(key);
        }
      });

      if (searchInput && searchInput.value.trim()) {
        params.set('busca', searchInput.value.trim());
      } else {
        params.delete('busca');
      }

      var newQuery = params.toString();
      var newUrl = window.location.pathname + (newQuery ? '?' + newQuery : '');
      window.history.replaceState({}, '', newUrl);
    }

    var DEFAULT_CATEGORY_LABEL = 'Novidades';

    function findDefaultCategoryValue() {
      if (!categorySelect) return '';
      for (var i = 0; i < categorySelect.options.length; i++) {
        if (categorySelect.options[i].textContent.trim() === DEFAULT_CATEGORY_LABEL) {
          return categorySelect.options[i].value;
        }
      }
      return '';
    }

    function loadFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var hasAnyFilterParam = !!(
        params.get('categoria') || params.get('cor') || params.get('tamanho') ||
        params.get('ordenar') || params.get('busca')
      );

      if (categorySelect && params.get('categoria')) {
        categorySelect.value = params.get('categoria');
      } else if (categorySelect && !hasAnyFilterParam) {
        var defaultValue = findDefaultCategoryValue();
        if (defaultValue) categorySelect.value = defaultValue;
      }

      if (colorSelect && params.get('cor')) colorSelect.value = params.get('cor');
      if (sizeSelect && params.get('tamanho')) sizeSelect.value = params.get('tamanho');
      if (sortSelect && params.get('ordenar')) sortSelect.value = params.get('ordenar');
      if (searchInput && params.get('busca')) searchInput.value = params.get('busca');
    }

    function loadNextPage(onDone) {
      var nextUrl = loadMoreBtn ? loadMoreBtn.getAttribute('data-next-url') : null;
      var sectionId = loadMoreBtn ? loadMoreBtn.getAttribute('data-section-id') : null;

      if (!loadMoreBtn || !nextUrl) {
        onDone(false);
        return;
      }

      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = 'Carregando...';

      var sep = nextUrl.indexOf('?') !== -1 ? '&' : '?';
      fetch(nextUrl + sep + 'section_id=' + sectionId)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newList = doc.querySelector('[data-catalogo-list]');
          var newButton = doc.querySelector('[data-catalogo-loadmore]');

          if (newList) {
            Array.prototype.slice.call(newList.querySelectorAll('[data-catalogo-item]')).forEach(function (item) {
              list.appendChild(item);
              bindItem(item, catalogItems);
            });
          }

          if (newButton) {
            loadMoreBtn.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = 'Carregar mais produtos';
            onDone(true);
          } else {
            loadMoreBtn.remove();
            loadMoreBtn = null;
            onDone(true);
          }
        })
        .catch(function () {
          if (loadMoreBtn) {
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = 'Carregar mais produtos';
          }
          onDone(false);
        });
    }

    var searchGeneration = 0;

    function ensureVisibleOrExhausted() {
      if (items !== catalogItems) {
        finalizeFilterPass();
        return;
      }

      var myGeneration = ++searchGeneration;

      applyFilters();
      applySort();

      if (countVisible() > 0 || !loadMoreBtn) {
        if (emptyMsg) {
          emptyMsg.textContent = emptyMsgOriginalText;
          emptyMsg.hidden = countVisible() !== 0;
        }
        return;
      }

      list.classList.add('is-loading-filter');
      if (loadMoreBtn) loadMoreBtn.hidden = true;
      if (emptyMsg) {
        emptyMsg.textContent = 'Buscando em todo o catálogo...';
        emptyMsg.hidden = false;
      }

      function finish() {
        if (myGeneration !== searchGeneration) return;
        list.classList.remove('is-loading-filter');
        if (loadMoreBtn) loadMoreBtn.hidden = false;
        applyFilters();
        applySort();
        if (emptyMsg) {
          emptyMsg.textContent = emptyMsgOriginalText;
          emptyMsg.hidden = countVisible() !== 0;
        }
      }

      function step() {
        if (myGeneration !== searchGeneration) return;
        if (!loadMoreBtn) {
          finish();
          return;
        }
        loadNextPage(function (hadMore) {
          if (myGeneration !== searchGeneration) return;
          applyFilters();
          applySort();
          if (countVisible() > 0 || !hadMore) {
            finish();
          } else {
            step();
          }
        });
      }

      step();
    }

    function switchToAllCatalogView() {
      currentCategoryHandle = '';
      if (items !== catalogItems) {
        list.innerHTML = '';
        while (allCatalogHolder.firstChild) {
          list.appendChild(allCatalogHolder.firstChild);
        }
        items = catalogItems;
      }
      if (loadMoreBtn) loadMoreBtn.hidden = false;
      ensureVisibleOrExhausted();
    }

    function switchToCategoryView(handle) {
      if (!handle) {
        switchToAllCatalogView();
        return;
      }

      if (handle === currentCategoryHandle) {
        finalizeFilterPass();
        return;
      }

      list.classList.add('is-loading-filter');
      if (emptyMsg) {
        emptyMsg.textContent = 'Carregando categoria...';
        emptyMsg.hidden = false;
      }
      if (loadMoreBtn) loadMoreBtn.hidden = true;

      if (items === catalogItems && list.firstChild) {
        while (list.firstChild) {
          allCatalogHolder.appendChild(list.firstChild);
        }
      } else {
        list.innerHTML = '';
      }

      var url = '/collections/' + handle + '?view=' + fragmentView;
      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fragList = doc.querySelector('[data-catalogo-fragment-list]');

          list.classList.remove('is-loading-filter');

          categoryItems = [];
          if (fragList) {
            Array.prototype.slice.call(fragList.querySelectorAll('[data-catalogo-item]')).forEach(function (item) {
              list.appendChild(item);
              bindItem(item, categoryItems);
            });

            var hasNext = fragList.getAttribute('data-has-next');
            if (loadMoreBtn) {
              loadMoreBtn.hidden = hasNext !== 'true';
            }
          }

          currentCategoryHandle = handle;
          items = categoryItems;
          finalizeFilterPass();
        })
        .catch(function () {
          list.classList.remove('is-loading-filter');
          if (emptyMsg) {
            emptyMsg.textContent = 'Não foi possível carregar essa categoria. Tente novamente.';
            emptyMsg.hidden = false;
          }
        });
    }

    loadFromUrl();

    if (categorySelect && categorySelect.value) {
      switchToCategoryView(categorySelect.value);
    } else {
      ensureVisibleOrExhausted();
    }

    if (categorySelect) {
      categorySelect.addEventListener('change', function () {
        if (categorySelect.value) {
          switchToCategoryView(categorySelect.value);
        } else {
          switchToAllCatalogView();
        }
        updateUrl();
      });
    }

    [colorSelect, sizeSelect, sortSelect].forEach(function (select) {
      if (select) {
        select.addEventListener('change', function () {
          ensureVisibleOrExhausted();
          updateUrl();
        });
      }
    });

    function updateSearchClear() {
      if (!searchClearBtn) return;
      searchClearBtn.hidden = !searchInput || searchInput.value.length === 0;
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        updateSearchClear();
        ensureVisibleOrExhausted();
        updateUrl();
      });
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          searchInput.blur();
        }
      });
      updateSearchClear();
    }

    if (searchClearBtn) {
      searchClearBtn.addEventListener('click', function () {
        searchInput.value = '';
        updateSearchClear();
        ensureVisibleOrExhausted();
        updateUrl();
        searchInput.blur();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (colorSelect) colorSelect.value = '';
        if (sizeSelect) sizeSelect.value = '';
        if (sortSelect) sortSelect.value = '';
        if (searchInput) searchInput.value = '';
        updateSearchClear();
        if (categorySelect) categorySelect.value = '';
        switchToAllCatalogView();
        updateUrl();
      });
    }

    var copyLinkBtn = document.querySelector('[data-copy-link]');
    if (copyLinkBtn) {
      copyLinkBtn.addEventListener('click', function () {
        var url = window.location.href;
        var originalText = copyLinkBtn.textContent;

        function showCopied() {
          copyLinkBtn.textContent = 'Link copiado!';
          setTimeout(function () {
            copyLinkBtn.textContent = originalText;
          }, 2000);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(showCopied).catch(function () {
            window.prompt('Copie o link abaixo:', url);
          });
        } else {
          window.prompt('Copie o link abaixo:', url);
        }
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        if (items !== catalogItems) return;
        loadNextPage(function () {
          applyFilters();
          applySort();
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
